<script>
  export let size = "24";
  export let color = "currentColor";
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  fill="none"
  viewBox="0 0 24 24"
  stroke-width="1.5"
  width={size}
  height={size}
>
  <path
    style="stroke: {color} !important;"
    stroke-linecap="round"
    stroke-linejoin="round"
    d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
  />
</svg>
